let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f35QR")).then(() => parcelRequire('9W0IA'));